import { Button, ButtonMode } from '@creditsights/styleguide-web';
import classNames from 'classnames';
import React from 'react';
import styles from '../Modal.module.scss';

interface Step4Props {
  onOneMore: () => void;
}

const Step4 = ({ onOneMore }: Step4Props): React.ReactElement => {
  return (
    <>
      <div className={classNames(styles.modalHeader, { [styles.modalHeaderThanks]: true })}>
        Your request has been submitted.
      </div>
      <div className={styles.modalSubHeader}>
        Thank you for your submission! A member of our team will review your request and reach out should anything
        additional be needed.
      </div>
      <div className={styles.modalOneMore}>
        <Button mode={ButtonMode.PRIMARY} className={styles.modalFormButton} onClick={onOneMore}>
          Begin a new research request
        </Button>
      </div>
    </>
  );
};

export default Step4;
